import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId:"ap-southeast-2_m16qdmbSK" ,
    ClientId: "5rmosqja9ii1gi4f3b5isk621c",
    clientSecret:"1h0hm2oplc1leu76co1bpsd6qb3so0ucgbumpg8olrpksdter13m"
};
const UserPool = new CognitoUserPool(poolData);

export default UserPool;